import { Column, RawColumn } from './column';
import {
  hasColloquial,
  hasReadPath,
  hasRelationships,
  hasColumnValidatorFn,
  hasRules,
  hasEDPIngestion,
} from './column-composition-fns';

/**
 * Transforms RawColumn to Column
 * @param column - the db or raw column
 */
export const ColumnFactory = <OUT extends RawColumn = Column, IN extends RawColumn = RawColumn>(column: IN): OUT => {
  return Object.assign(
    column,
    hasEDPIngestion(),
    hasReadPath(),
    hasRelationships(),
    hasColloquial(),
    hasColumnValidatorFn(),
    hasRules()
  );
};
